import T from "@marginly/ui/components/typography";
import React from "react";

import { getTokenSymbol } from "@/app/util";
import { formatCoin } from "@/util/format-coin";

import * as S from "./styled";

interface Props {
  debt?: number;
  collateral?: number;
  tokenSymbol?: string;
}

export function PoolProgress({ collateral, debt, tokenSymbol }: Props) {
  if (collateral === undefined || debt === undefined) return null;
  const ration = (debt / (collateral || 1)) * 100;
  return (
    <div>
      <S.Progress>
        <S.Painted style={{ width: `${ration}%` }} />
      </S.Progress>
      <S.Description>
        <T caption secondary>
          {formatCoin(debt)} / {formatCoin(collateral)}{" "}
          {getTokenSymbol(tokenSymbol)} utilized
        </T>
      </S.Description>
    </div>
  );
}
